import styled from 'styled-components'

import {
  color,
  ColorKeysWithoutGradient,
  radius,
  space,
  SpaceProps,
  Theme,
} from '../../themes'

interface GradientBoxBaseProps extends SpaceProps {
  alignItems?: 'flex-start' | 'center' | 'flex-end'
  justifyContent?: 'flex-start' | 'center' | 'flex-end'
  bgColor: ColorKeysWithoutGradient<Theme>
  isNeutral?: boolean
}

export const GradientBoxBase = styled.div<GradientBoxBaseProps>`
  ${space}

  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: ${({ alignItems = 'flex-start' }) => alignItems};
  justify-content: ${({ justifyContent = 'flex-start' }) => justifyContent};

  &::before {
    content: '';
    position: absolute;
    background: ${({ isNeutral }) =>
      !isNeutral ? color('gradient.primary') : color('gray.03')};
    transition: background 0.3s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${radius('md')};
    z-index: -2;
    left: -1px;
    top: -1px;
    right: -1px;
    bottom: -1px;
  }

  &::after {
    content: '';
    position: absolute;
    display: flex;
    background: ${({ bgColor }) => color(bgColor)};
    border-radius: ${({ theme }) => theme.radius.md - 1}px;
    z-index: -1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`
